// Forint összegek egységes megjelenítése.
// A backend a Prisma Decimal mezőket szövegként küldi ("12500000.00"), ezért mindig számmá alakítunk —
// szövegen a toLocaleString nem formáz, így jelent meg korábban pl. "12500000 Ft".

const toNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

// 12500000 → "12 500 000 Ft"
export const formatHuf = (value, { fallback = '–' } = {}) => {
  const n = toNumber(value);
  if (n === null) return fallback;
  return `${Math.round(n).toLocaleString('hu-HU')} Ft`;
};

// Szűk helyre (kártyák): 12500000 → "12,5 M Ft", 850000 → "850 E Ft"
export const formatHufCompact = (value, { fallback = '–' } = {}) => {
  const n = toNumber(value);
  if (n === null) return fallback;
  const abs = Math.abs(n);
  const fmt = (x) => x.toLocaleString('hu-HU', { maximumFractionDigits: 1 });
  if (abs >= 1_000_000) return `${fmt(n / 1_000_000)} M Ft`;
  if (abs >= 10_000) return `${fmt(n / 1_000)} E Ft`;
  return formatHuf(n);
};

// Csomagár egységgel. A tárolt egységkód ékezet nélküli lehet (pl. '/ora'), ezért megjelenítéskor
// a magyar alakra fordítjuk — korábban „25 000 Ft /ora” jelent meg.
const PRICE_UNIT_DISPLAY = { '/ora': '/óra' };
export const formatPackagePrice = (price, priceUnit) => {
  const formatted = formatHuf(price);
  if (!priceUnit || priceUnit === 'total') return formatted;
  return `${formatted} ${PRICE_UNIT_DISPLAY[priceUnit] || priceUnit}`;
};
